import AffiliatesAction from '../actions/AffiliatesCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { AffiliatesState } from '../interfaces/affiliates';

const initialState: AffiliatesState = {
  busy: false,
  affiliate: undefined,
};

export default function analytics(state = initialState, action) {
  switch (action.type) {
    case AffiliatesAction.busyAction:
      return setBusy(state);
    case AffiliatesAction.retrievedAction: {
      return {
        ...state,
        affiliate: action.entity,
        busy: false,
      };
    }
    case AffiliatesAction.deactivateAction: {
      return {
        ...state,
        busy: false,
        affiliate: { ...state.affiliate, approved: false },
      };
    }
    case AffiliatesAction.unbusyAction:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
